import React from 'react';
import { AppBar, Toolbar, Typography, Breadcrumbs, Link as MuiLink, Avatar } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.js';
import '../styles/components/Header.scss';

const breadcrumbNameMap = {
  '/': 'Inicio',
  '/userslist': 'Usuarios',
  '/profile': 'Perfil de Usuario',
  '/templateslist': 'Firmas de correo',
  '/keywords': 'Palabras claves',
  '/schedulertasks': 'Tareas programadas',
  '/workplacesusers': 'Usuarios de dominio',
  '/loaddata': 'Importar cuentas de dominio',
  '/special-rules': 'Reglas especiales',
  '/special-templates': 'Plantillas Especiales'
};

const Header = () => {
  const { user } = useAuth();
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);
  return (
    <AppBar position="static" className="header" color="transparent">
      <Toolbar className="toolbar">
        <Breadcrumbs aria-label="breadcrumb" className="breadcrumbs">
          <Link underline="hover" color="inherit" to="/">
            {breadcrumbNameMap['/']}
          </Link>
          {Array.isArray(pathnames) && pathnames.map((value, index) => {
            const to = `/${pathnames.slice(0, index + 1).join('/')}`;
            const isLast = index === pathnames.length - 1;
            const label = breadcrumbNameMap[to] || value.charAt(0).toUpperCase() + value.slice(1);
            return isLast ? (
              <Typography key={to} color="text.primary">
                {label}
              </Typography>
            ) : (
              <MuiLink
                key={to}
                component={Link}
                underline="hover"
                color="inherit"
                to={to}
              >
                {label}
              </MuiLink>
            );
          })}
        </Breadcrumbs>

        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="body1" className="email">
            {user?.email || ''}
          </Typography>
          <Avatar alt={user?.name || ''} src={user?.picture || ''} />
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
